import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Hyperlink } from '../../../../objects';
import { CalendarItem } from '../../services/calendar-item.service';

@Component({
  selector: 'app-calendar-item-edit-urls',
  templateUrl: './calendar-item-edit-urls.component.html',
  styleUrls: ['./calendar-item-edit-urls.component.css']
})
export class CalendarItemEditUrlsComponent implements OnInit {

  public showAddNewLink: Boolean = false;

  @Input() public calendarItem: CalendarItem[]; 
  @Output() public linksUpdated: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit() {

    this.showAddNewLink = false;
 
  }

  public addNew() {
    this.showAddNewLink = true;
    console.log("add new");
  }

  public updateLinks() {
    console.log("CalendarItemEditUrlsComponent: Update Links");
    this.showAddNewLink = false;
    this.linksUpdated.emit();
  }

}
